<template>
 <!--  <div>  -->
    <div class="main__details">
      <!-- <div class="line__vertical"></div>
      <div @click="goBack()" class="icon__close-box">
        <font-awesome-icon class="icon__close" :icon="closeIcon" />
      </div> -->
      <main class="main__box" :class="columnReverse">
        <div class="item1 item">
          <image-location
              class="image__location-small"
              :typeImage="typeImage"
            />
          <div :class="showLineHorizontal" class="line_horizontal-quote"></div>
          <detail-location />
          <div :class="hideLineHorizontal" class="line_horizontal"></div>
          <!-- <div v-if="stateForm == 2"> -->
            <amenities-location :amenitiesData="amenitiesData" />
            <div class="buttons__box">
              <!-- <btn-quote @click="showFormQuote" />
              <btn-recibir-info @click="showFormRecibirInfo" /> -->
            </div>
          <!-- </div> -->
          <!-- <div v-else>
            
          </div> -->
        </div>
        <div class="item2 item">
          <!-- <image-location v-if="stateForm == 2" :typeImage="typeImage" /> -->
          <form-quote
            :desarrollo="desarrollo"
            :stateForm="stateForm"
            @click="hiddeRecibirInfo"
          />
        </div>
      </main>
    </div>
    <!-- quitar cuando se suban individuales de los terrenos de priv 28 -->
    <!-- <MainPriv28 v-if="stateFormPrv28==237" /> -->
  <!-- </div> -->
</template>

<script>
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import DetailLocation from "../../../core/rediseno/DetailLocation";
import AmenitiesLocation from "../../../core/datalocation/AmenitiesLocation";
import FormQuote from "../../../core/rediseno/financial/FormQuote";
/* import BtnRecibirInfo from "../../../core/BtnRecibirInfo";
import BtnQuote from "../../../core/BtnQuote"; */
import ImageLocation from "../../../core/rediseno/ImageIndividual";
/* import MainPriv28 from "./MainPrv28.vue"; */
export default {
  name: "Main",
  data() {
    return {
      //estado 2 es la imagen, 1 el cotizador y 0 recibir info
      stateForm: 2,
      closeIcon: faXmark,
      deviceWidth: 0,
      typeImage: "terreno",
      desarrollo: "Cañadas Terrenos",
      amenitiesData: [
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/lagos.svg",
          description: "Lagos",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/canchasfut.svg",
          description: "Canchas de futbol y basquetbol",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/juegosinfantiles.svg",
          description: "Juegos infantiles",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/vigilancia.svg",
          description: "Seguridad",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/circuitocerrado.svg",
          description: "Circuito Cerrado",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/ciclopista.svg",
          description: "Ciclopista",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/trotapista.svg",
          description: "Trotapista",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/gym.svg",
          description: "Gimnasio al aire libre",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/cenadores.svg",
          description: "Cenadores",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/accesoespectacular.svg",
          description: "Espectacular acceso",
        },
        {
          icon: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/icons/pets.svg",
          description: "Pet Friendly",
        },
      ],
    };
  },
  components: {
    DetailLocation,
    AmenitiesLocation,
    //BtnRecibirInfo,
    FormQuote,
    ImageLocation,
    //BtnQuote,
    /* MainPriv28, */
  },
  computed: {
    stateFormPrv28() {
      if (this.$route.params.id === "237") {
        return 237;
      } else {
        return this.stateForm;
      }
    },
    columnReverse() {
      if (this.deviceWidth <= 1200) {
        if (this.stateForm == 1 || this.stateForm == 0) {
          return "main-reverse";
        }
      } else {
        return "main__box";
      }
      return "main__box";
    },
    hideLineHorizontal() {
      if (this.deviceWidth <= 1200) {
        if (this.stateForm == 1 || this.stateForm == 0) {
          return "hide__line";
        }
      }
      return "";
    },
    showLineHorizontal() {
      if (this.deviceWidth <= 1200) {
        if (this.stateForm == 1 || this.stateForm == 0) {
          return "show__line";
        }
      }
      return "";
    },
  },
  methods: {
    showFormRecibirInfo(stateForm) {
      this.stateForm = stateForm;
    },
    showFormQuote(stateForm) {
      this.stateForm = stateForm;
    },
    hiddeRecibirInfo(stateForm) {
      this.stateForm = stateForm;
    },
    goBack() {
      this.$router.go(-1);
    },
    getWidthWindow() {
      this.deviceWidth = window.innerWidth;
    },
  },
  mounted() {
    this.columnReverse;
  },
  created() {
    this.deviceWidth = innerWidth;
    window.addEventListener("resize", this.getWidthWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.getWidthWindow);
  },
};
</script>
<style >
.disp-none {
  display: none;
}
.disp-block {
  display: block;
}
</style>